export const removePropertyRecursively = <T extends Record<string, any>>(
  obj: T,
  propToRemove: string
): T => {
  if (Array.isArray(obj)) {
    return (obj.map((item) =>
      removePropertyRecursively(item, propToRemove)
    ) as unknown) as T;
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([key]) => key !== propToRemove)
        .map(([key, value]) => [
          key,
          removePropertyRecursively(value, propToRemove),
        ])
    ) as T;
  }
  return obj;
};
